@import '../../../../app-brand/entities/entity-layer.module.less';

@dropdown-width: 100%;
.dropdown-menu {
  width: @dropdown-width;
}

.dropdown-menu-item {
  font-size: 14px;
  width: @dropdown-width;
  display: flex;
  justify-content: space-between;
}

.icon {
  height: 12px;
  width: 16px;
}

.subtext {
  color: @dropdown-menu-item--subtext--text-color;
}
